import {styled} from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import ErrorIcon from '@mui/icons-material/Error'

export const StyledDiv = styled('div')(({theme}) => ({
  fontWeight: theme.typography.subtitle1.fontWeight,
  fontSize: theme.typography.subtitle1.fontSize,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.hpAccentBlack,
  display: 'inline'
}))

export const StyledDialog = styled(Dialog)(() => ({
  '&.MuiDialog-root': {
    zIndex: 1600
  },
  '& .MuiDialog-container': {
    alignItems: 'flex-start'
  }
}))

export const StyledErrorIcon = styled(ErrorIcon)(({theme}) => ({
  color: theme.palette.error.main,
  marginTop: '2px',
  float: 'left',
  marginRight: '5px'
}))
